"use client";

import { useCallback } from "react";

import { DetectExportLanguage, generateDetectCode } from "@perceptron/api/codeGenerators";
import { strings } from "@perceptron/constants";

import ExportDialogShell from "@demo/components/ExportCode/ExportDialogShell";
import { type ExportLanguageOption } from "@demo/components/ExportCode/types";
import { useDetectStore } from "@demo/store/detect";

import { buildDetectConfig } from "./buildDetectConfig";

// cURL only today; the SDK-based Python tab is deferred until the `perceptron` SDK
// exposes a detect primitive (PRO-970), at which point it leads this list.
const LANGUAGES: ExportLanguageOption[] = [{ value: "curl", label: "cURL", highlighter: "json" }];

/**
 * Detect's export: a copyable `POST /v1/detect` cURL snippet for the selected
 * image + categories + config. Reads the detect store, builds the request
 * config, and feeds the shared dialog shell. Registered per-mode in
 * `components/ExportCode/registry`.
 */
const DetectExport = () => {
  const getCode = useCallback((apiKey: string, language: string) => {
    const { image, categories, outputType, enableThinking } = useDetectStore.getState();
    const config = buildDetectConfig({ image, categories, outputType, enableThinking, apiKey });
    return generateDetectCode(config, language as DetectExportLanguage);
  }, []);

  return (
    <ExportDialogShell
      description={strings.exportCode.modes.detect.description}
      getCode={getCode}
      languages={LANGUAGES}
      title={strings.exportCode.modes.detect.title}
    />
  );
};

export default DetectExport;
